import { Alert, Button, DownloadIcon, Grid } from '@gogame/components';

import { useDownloadErrorFile } from 'scenes/TapjoyBidUpdate/data/mutations';
import { useStatusCompactDetails } from 'scenes/TapjoyBidUpdate/hooks/useStatusCompactDetails';
import { useLoadErrorDetails } from 'scenes/TapjoyBidUpdate/data/useLoadErrorDetails';

export default ({ statusDetails }) => {
  const { data: errorDetails } = useLoadErrorDetails();
  const [downloadErrorFile] = useDownloadErrorFile();
  const handleDownloadErrorsFile = async () => {
    await downloadErrorFile({
      reportUid: errorDetails.reportUid,
    });
  };
  const getStatusCompactDetails = useStatusCompactDetails();
  if (!errorDetails) {
    return null;
  }
  return (
    <Grid item>
      <Alert
        severity={'error'}
        title={errorDetails.errorMessage}
        action={
          <Button
            startIcon={<DownloadIcon />}
            onClick={handleDownloadErrorsFile}
          >
            Download errors
          </Button>
        }
      >
        {getStatusCompactDetails('Failed', statusDetails)}
      </Alert>
    </Grid>
  );
};
